import { createFileRoute } from '@tanstack/react-router'
import { CustomerSupportSection, customerSupportLoader } from '@spcc/domains/support'

export const Route = createFileRoute('/support')({
  loader: async ({ context }) => customerSupportLoader({ context }),
  component: SupportPage,
})

function SupportPage() {
  return <CustomerSupportSection />
}
